import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { useApp } from '@/context/AppContext';

const SESSION_FLAG = 'sankhya_reupload_banner_shown';

export default function ReuploadBanner({ setView }) {
  const { profile, needsResumeReupload } = useApp();
  const fired = useRef(false);

  useEffect(() => {
    if (!profile) return;
    if (!needsResumeReupload) return;
    if (fired.current) return;
    if (sessionStorage.getItem(SESSION_FLAG)) return;

    fired.current = true;
    sessionStorage.setItem(SESSION_FLAG, '1');

    toast.info(
      'Sankhya just upgraded its database. Please re-upload your resume to keep your job matching accurate. Your account and settings are unchanged.',
      {
        duration: Infinity,
        action: {
          label: 'Upload now',
          onClick: () => setView('resume'),
        },
      }
    );
  }, [profile, needsResumeReupload, setView]);

  return null;
}
